import discovery from '../discovery';
import { HTTP, UTILS } from '../http-common';

// === WKT-2322: Límites de validación de adjuntos (leídos del backend en TConfiguration) ===
// Defaults: 50 MB por archivo y 5 adjuntos por mensaje.
// initUploadLimits() los actualiza desde el backend al iniciar la app.
let SUPPORT_MAX_ATTACHMENT_BYTES = 50 * 1024 * 1024;
let SUPPORT_MAX_ATTACHMENTS = 5;

function getSupportMaxAttachmentMegabytes() {
    const bytesPerMegabyte = 1024 * 1024;
    const megabytes = SUPPORT_MAX_ATTACHMENT_BYTES / bytesPerMegabyte;
    return Number.isInteger(megabytes) ? String(megabytes) : megabytes.toFixed(1);
}

export async function initUploadLimits() {
    try {
        const res = await HTTP.get(discovery.worktime_service_url + 'rest/upload-config');
        if (res && res.data) {
            SUPPORT_MAX_ATTACHMENT_BYTES = res.data.maxAttachmentBytes || SUPPORT_MAX_ATTACHMENT_BYTES;
            SUPPORT_MAX_ATTACHMENTS = res.data.maxAttachments || SUPPORT_MAX_ATTACHMENTS;
        }
    } catch (e) {
        // Mantener defaults si falla
        console.warn('[WKT-2322] No se pudo cargar upload-config, usando defaults', e);
    }
}
// === fin WKT-2322 ===

export default {
    // === WKT-2322: Validación de adjuntos Soporte/Incidencias ===
    // Devuelve null si OK, o mensaje i18n parametrizado si excede límites.
    validateSupportAttachments(files) {
        if (!files || files.length === 0) {
            return null; // sin adjuntos: OK
        }
        if (files.length > SUPPORT_MAX_ATTACHMENTS) {
            return {
                key: 'wkt.admin.customer.support.dialog.error.too_many_files',
                params: { max: SUPPORT_MAX_ATTACHMENTS }
            };
        }
        for (let i = 0; i < files.length; i++) {
            if (files[i].size > SUPPORT_MAX_ATTACHMENT_BYTES) {
                return {
                    key: 'wkt.admin.customer.support.dialog.error.file_too_large',
                    params: { max: getSupportMaxAttachmentMegabytes() }
                };
            }
        }
        return null;
    },
    // === fin WKT-2322 ===

    getCommonHeaders(options = {}) {
        var headers = {};
        const omitGlobalFilters = options.omitGlobalFilters === true;
        const extraHeaders = options.headers || {};

        headers = {
            'authorization': 'Bearer ' + window.kc_token
        };

        ///////////////////////////////////////////////////////////////
        // FIX multiples perfiles

        let employeeCompany = this.getContextValue('worktime.employee.company.id');
        if (employeeCompany) {
            headers['x-employee-company'] = employeeCompany;
            headers['x-client-company'] = employeeCompany;
        }

        ///////////////////////////////////////////////////////////////

        let adminCompany = this.getContextValue('worktime.admin.company.id');
        if (adminCompany) {
            headers['x-admin-company'] = adminCompany;
        }

        let employeeId = this.getContextValue('worktime.employee.id');
        if (employeeId) {
            headers['x-employee'] = employeeId;
        }

        const companyId = adminCompany ? adminCompany : employeeCompany;

        if (!omitGlobalFilters) {
            const wpFilterKey = `filter.company_id_${companyId}.workplace.id`;

            const workplaceId = window.localStorage.getItem(wpFilterKey);
            if (workplaceId && workplaceId !== "-1") {
                headers['x-workplace'] = workplaceId;
            }

            const dpFilterKey = `filter.company_id_${companyId}.department.id`;

            const departmentId = window.localStorage.getItem(dpFilterKey);
            if (departmentId && departmentId !== "-1") {
                headers['x-department'] = departmentId;
            }

            let legalEntityId = this.getContextValue('worktime.admin.legalEntity.id');

            if ((!legalEntityId || legalEntityId === "null") && companyId) {
                const leFilterKey = `filter.company_id_${companyId}.legalEntity.id`;
                legalEntityId = window.localStorage.getItem(leFilterKey);
            }

            if (legalEntityId && legalEntityId !== "-1" && legalEntityId !== "null") {
                headers['x-legal-entity'] = legalEntityId;
            }

            let projectId = this.getContextValue('worktime.admin.project.id');

            if ((!projectId || projectId === "null") && companyId) {
                const projectFilterKey = `filter.company_id_${companyId}.project.id`;
                projectId = window.localStorage.getItem(projectFilterKey);
            }

            if (projectId && projectId !== "-1" && projectId !== "null") {
                headers['x-project'] = projectId;
            }
        }

        if (/MSIE|Trident/.test(window.navigator.userAgent)) {
            headers['Pragma'] = 'no-cache';
            headers['Cache-Control'] = 'no-cache, no-store';
        }

        headers = {
            ...headers,
            ...extraHeaders
        };

        return { headers: headers };
    },
    genericGet(service, cbok, cberr, options = {}) {
        HTTP
            .get(discovery.worktime_service_url + service,
                this.getCommonHeaders(options))
            .then((response) => {
                cbok(response.data);
            }).catch(function (error) {
                cberr(error);
            });
    },
    genericPut(service, data, cbok, cberr, options = {}) {
        HTTP
            .put(discovery.worktime_service_url + service,
                data, this.getCommonHeaders(options))
            .then((response) => {
                if (cbok)
                    cbok(response.data);
            }).catch(function (error) {
                if (cberr)
                    cberr(error);
            });
    },
    genericPost(service, data, cbok, cberr, options = {}) {
        HTTP
            .post(discovery.worktime_service_url + service,
                data, this.getCommonHeaders(options))
            .then((response) => {
                cbok(response.data);
            }).catch(function (error) {
                cberr(error);
            });
    },
    genericDelete(service, cbok, cberr) {
        HTTP
            .delete(discovery.worktime_service_url + service,
                this.getCommonHeaders())
            .then((response) => {
                cbok(response.data);
            }).catch(function (error) {
                cberr(error);
            });
    },
    getContextValue(key) {
        return window.tweemContext ? window.tweemContext[key] : '';
    },
    /////////////////////////////////////////////////////////////////
    //COMMON 

    getStaff(cbok, cberr, options = {}) {
        this.genericGet('admin/staff', cbok, cberr, options);
    },
    getStaffWithoutGlobalFilters(cbok, cberr) {
        this.genericGet('admin/staff', cbok, cberr, { omitGlobalFilters: true });
    },
    getWorkPlaces(cbok, cberr, options = {}) {
        this.genericGet('admin/getworkPlace', cbok, cberr, options);
    },
    getWorkPlacesWithoutGlobalFilters(cbok, cberr) {
        this.genericGet('admin/getworkPlace', cbok, cberr, { omitGlobalFilters: true });
    },
    getProjects(cbok, cberr, options = {}) {
        this.genericGet('admin/projectsAll', cbok, cberr, options);
    },
    executeQuery(data, cbok, cberr) {
        this.genericPost('analytics/executeQuery', data, cbok, cberr, { omitGlobalFilters: true });
    },
    getAnalyticsReportTypeById(id, cbok, cberr) {
        this.genericGet('analytics/reportType/' + id, cbok, cberr, { omitGlobalFilters: true });
    },
    getAnalyticsReportTypes(module, cbok, cberr) {
        this.genericGet('analytics/reportType/list/' + module, cbok, cberr, { omitGlobalFilters: true });
    },
    downloadAnalyticsReport(data, cbok, cberr) {
        let options = this.getCommonHeaders({ omitGlobalFilters: true });
        options.responseType = 'blob';
        HTTP
            .post(discovery.worktime_service_url + 'analytics/reportDownload',
                data, options)
            .then((response) => {
                if (cbok) {
                    cbok(response.data);
                }
                UTILS.downloadDocument(response);
            }).catch(function (error) {
                if (cberr) {
                    cberr(error);
                }
            });
    },
    /////////////////////////////////////////////////////////////////
    //Automation

    getTasks(offset, limit, onlyAssignedToMe, status, hiddenOnly, textFilter, cbok, cberr) {
        this.genericGet('automation/admin/tasks/' + offset + '/' + limit + '/' + onlyAssignedToMe + '/' + status + '/' + hiddenOnly + '/' + encodeURIComponent(textFilter || 'none'), cbok, cberr);
    },
    getTask(id, cbok, cberr) {
        this.genericGet('automation/admin/task/' + id, cbok, cberr);
    },
    getTaskEvents(id, cbok, cberr) {
        this.genericGet('automation/admin/task/' + id + '/events', cbok, cberr);
    },
    storeTask(data, cbok, cberr) {
        this.genericPost('automation/admin/task', data, cbok, cberr);
    },
    storeTaskComment(taskId, data, cbok, cberr) {
        this.genericPost('automation/admin/task/' + taskId + '/comment', data, cbok, cberr);
    },
    uploadTaskCommentAttachment(taskId, commentId, data, cbok, cberr) {
        HTTP
            .post(discovery.worktime_service_url + 'automation/admin/task/' + taskId + '/comment/' + commentId + '/attachment',
                data, this.getCommonHeaders())
            .then((response) => {
                if (cbok) {
                    cbok(response.data);
                }
            }).catch(function (error) {
                if (cberr) {
                    cberr(error);
                }
            });
    },
    downloadTaskCommentAttachment(taskId, commentId, attachmentId, cbok, cberr) {
        let options = this.getCommonHeaders();
        options.responseType = 'blob';
        HTTP
            .get(discovery.worktime_service_url + 'automation/admin/task/' + taskId + '/comment/' + commentId + '/attachment/' + attachmentId, options)
            .then((response) => {
                if (cbok) {
                    cbok(response.data);
                }

                UTILS.downloadDocument(response);
            }).catch(function (error) {
                if (cberr) {
                    cberr(error);
                }
            });
    },
    markTaskAsSeen(taskId, taskEventId, cbok, cberr) {
        this.genericPost('automation/admin/task/' + taskId + '/seen/' + taskEventId, {}, cbok, cberr);
    },
    updateTaskStatus(taskId, status, cbok, cberr) {
        this.genericPost('automation/admin/task/' + taskId + '/status/' + status, {}, cbok, cberr);
    },
    deleteTask(id, cbok, cberr) {
        this.genericDelete('automation/admin/task/' + id, cbok, cberr);
    },
    getWorkflows(offset, limit, textFilter, cbok, cberr) {
        this.genericGet('automation/admin/workflows/' + offset + '/' + limit + '/' + encodeURIComponent(textFilter || 'none'), cbok, cberr);
    },
    getWorkflow(id, cbok, cberr) {
        this.genericGet('automation/admin/workflow/' + id, cbok, cberr);
    },
    getWorkflowTemplates(cbok, cberr) {
        this.genericGet('automation/admin/workflow/templates', cbok, cberr);
    },
    getWorkflowEventTypes(cbok, cberr) {
        this.genericGet('automation/admin/workflow/events', cbok, cberr);
    },
    getWorkflowActionTypes(cbok, cberr) {
        this.genericGet('automation/admin/workflow/actions', cbok, cberr);
    },
    getWorkflowSourceDocuments(cbok, cberr) {
        this.genericGet('automation/admin/workflow/source-documents', cbok, cberr);
    },
    getWorkflowForms(cbok, cberr) {
        this.genericGet('automation/admin/workflow/forms', cbok, cberr);
    },
    getWorkflowExecutionLogs(id, cbok, cberr) {
        this.genericGet('automation/admin/workflow/' + id + '/execution-logs', cbok, cberr);
    },
    storeWorkflow(data, cbok, cberr) {
        this.genericPost('automation/admin/workflow', data, cbok, cberr);
    },
    createWorkflowFromTemplate(code, cbok, cberr) {
        this.genericPost('automation/admin/workflow/template/' + encodeURIComponent(code), {}, cbok, cberr);
    },
    executeWorkflow(id, data, cbok, cberr) {
        this.genericPost('automation/admin/workflow/' + id + '/execute', data, cbok, cberr);
    },
    duplicateWorkflow(id, cbok, cberr) {
        this.genericPost('automation/admin/workflow/' + id + '/duplicate', {}, cbok, cberr);
    },
    toggleWorkflow(id, enabled, cbok, cberr) {
        this.genericPost('automation/admin/workflow/' + id + '/enabled/' + enabled, {}, cbok, cberr);
    },
    deleteWorkflow(id, cbok, cberr) {
        this.genericDelete('automation/admin/workflow/' + id, cbok, cberr);
    },
    getCompanies(cbok, cberr) {
        this.genericGet('admin/companies', cbok, cberr);
    },
    getCompany(cbok, cberr) {
        this.genericGet('admin/company', cbok, cberr);
    },
    getWorkplacesByCompanyId(companyId, cbok, cberr) {
        this.genericGet('admin/workplaces-by-company-id/' + companyId, cbok, cberr);
    },

    /////////////////////////////////////////////////////////////////
    //Dialog manager

    getDialog(id, cbok, cberr) {
        this.genericGet('dialog/' + id, cbok, cberr);
    },
    deleteDialog(id, cbok, cberr) {
        this.genericDelete('dialog/' + id, cbok, cberr);
    },
    storeDialog(module, cbok, cberr) {
        this.genericPost('dialog/', module, cbok, cberr);
    },
    getDialogs(cbok, cberr) {
        this.genericGet('dialog/config', cbok, cberr);
    },

    /////////////////////////////////////////////////////////////////
    //Module manager

    getModule(id, cbok, cberr) {
        this.genericGet(`module/${id}?_ts=${Date.now()}`, cbok, cberr);
    },
    deleteModule(id, cbok, cberr) {
        this.genericDelete('module/' + id, cbok, cberr);
    },
    storeModule(module, cbok, cberr) {
        this.genericPost('module/', module, cbok, cberr);
    },
    getModules(cbok, cberr) {
        this.genericGet(`module/config?_ts=${Date.now()}`, cbok, cberr);
    },
    getModuleData(id, context, cbok, cberr) {
        this.genericPost('module/data/' + id, context, cbok, cberr);
    },
    /////////////////////////////////////////////////////////////////
    //Export module

    downloadExportCSV(id, cbok, cberr) {
        let options = this.getCommonHeaders();
        options.responseType = 'blob';
        HTTP
            .get(discovery.worktime_service_url + 'admin/download-export-csv/' + id, options)
            .then((response) => {
                if (cbok) {
                    cbok(response.data);
                }

                UTILS.downloadDocument(response);

            }).catch(function (error) {
                if (cberr) {
                    cberr(error);
                }
            });
    },
    getLinkDownloadExportCSV(id, cbok, cberr) {
        HTTP
            .get(discovery.worktime_service_url + 'admin/export-csv-link/' + id, this.getCommonHeaders())
            .then((response) => {
                if (cbok) {
                    let url = discovery.worktime_service_url;
                    url = url.replace('/rest/', '');
                    url = `${url}/${response.data}`;
                    cbok(url);
                }
            }).catch(function (error) {
                if (cberr) {
                    cberr(error);
                }
            });
    },
    deleteExport(id, cbok, cberr) {
        this.genericDelete('admin/delete-export/' + id, cbok, cberr);
    },

    /////////////////////////////////////////////////////////////////
    //External document category

    getExternalDocumentCategory(id, cbok, cberr) {
        this.genericGet('admin/external-document-category-by-id/' + id, cbok, cberr);
    },
    deleteExternalDocumentCategory(id, cbok, cberr) {
        this.genericDelete('admin/external-document-category/' + id, cbok, cberr);
    },
    storeExternalDocumentCategory(data, cbok, cberr) {
        this.genericPost('admin/external-document-category', data, cbok, cberr);
    },

    /////////////////////////////////////////////////////////////////
    //Support ticket

    getSupportTicket(isAdmin, id, cbok, cberr) {
        let path = isAdmin ? 'support/admin' : 'support/customer';
        this.genericGet(path + '/ticket/' + id, cbok, cberr);
    },
    getSupportTicketMessages(isAdmin, id, cbok, cberr) {
        let path = isAdmin ? 'support/admin' : 'support/customer';
        this.genericGet(path + '/ticket/' + id + '/message', cbok, cberr);
    },
    deleteSupportTicket(id, cbok, cberr) {
        this.genericDelete('support/admin/ticket/' + id, cbok, cberr);
    },
    storeSupportTicket(isAdmin, data, cbok, cberr) {
        let path = isAdmin ? 'support/admin' : 'support/customer';
        this.genericPost(
            path+'/ticket',
            this.encodeSupportTicketPayload(data),
            cbok,
            cberr,
            this.getSupportPayloadEncodingOptions()
        );
    },
    extractErrorMessage(error) {
        if (error && error.response && error.response.data) {
            const data = error.response.data;
            if (typeof data === 'string' && data.trim().length > 0) {
                return data;
            }
            if (data && typeof data.message === 'string' && data.message.trim().length > 0) {
                return data.message;
            }
        }
        return null;
    },
    storeSupportTicketMessage (isAdmin, ticketId, data, cbok, cberr)
    {
        let path = isAdmin ? 'support/admin' : 'support/customer';

        if (typeof FormData !== 'undefined' && data instanceof FormData) {
            const headers = this.getCommonHeaders().headers;
            headers['Content-Type'] = 'multipart/form-data';

            HTTP
                .post(discovery.worktime_service_url + path + '/ticket/' + ticketId + '/message',
                    data, { headers: headers })
                .then((response) => {
                    if (cbok) {
                        cbok(response.data);
                    }
                }).catch((error) => {
                    if (cberr) {
                        const message = this.extractErrorMessage(error) || (error && error.message) || error;
                        cberr(message);
                    }
                });
            return;
        }

        this.genericPost(
            path+'/ticket/'+ticketId+'/message',
            this.encodeSupportTicketMessagePayload(data),
            cbok,
            (error) => cberr && cberr(this.extractErrorMessage(error) || (error && error.message) || error),
            this.getSupportPayloadEncodingOptions()
        );
    },  
    getSupportPayloadEncodingOptions() {
        return {
            headers: {
                'x-support-payload-encoding': 'base64'
            }
        };
    },
    encodeSupportTicketPayload(data) {
        if (!data) {
            return data;
        }

        return {
            ...data,
            title: this.encodeSupportPayloadValue(data.title),
            description: this.encodeSupportPayloadValue(data.description)
        };
    },
    encodeSupportTicketMessagePayload(data) {
        if (!data) {
            return data;
        }

        return {
            ...data,
            message: this.encodeSupportPayloadValue(data.message),
            files: Array.isArray(data.files) ? data.files.map(file => file ? ({
                ...file,
                fileName: this.encodeSupportPayloadValue(file.fileName)
            }) : file) : data.files
        };
    },
    encodeSupportPayloadValue(value) {
        return typeof value === 'string' ? this.encodeBase64(value) : value;
    },
    readFileAsBase64(file) {
        return new Promise((resolve, reject) => {
            if (!file) {
                resolve('');
                return;
            }

            const reader = new FileReader();
            reader.onload = () => {
                const result = typeof reader.result === 'string' ? reader.result : '';
                const base64Content = result.indexOf(',') >= 0 ? result.split(',')[1] : result;
                resolve(base64Content);
            };
            reader.onerror = () => {
                reject(new Error('No se ha podido leer el archivo adjunto'));
            };
            reader.readAsDataURL(file);
        });
    },
    async buildSupportTicketMessagePayload(ticketId, isPublic, message, files) {
        const safeFiles = files ? Array.from(files) : [];
        const encodedFiles = await Promise.all(safeFiles.map(async (file) => ({
            fileName: file.name,
            contentType: file.type,
            documentFile: await this.readFileAsBase64(file)
        })));

        return {
            ticketId: ticketId,
            isPublic: isPublic,
            message: message,
            files: encodedFiles
        };
    },
    buildSupportTicketMessageFormData(ticketId, isPublic, message, files) {
        const formData = new FormData();
        formData.append('ticketId', ticketId);
        formData.append('isPublic', isPublic);
        formData.append('message', message);
        if (files && files.length > 0) {
            for (let i = 0; i < files.length; i++) {
                const file = files[i];
                formData.append('file', file, file.name);
            }
        }
        return formData;
    },
    downloadSupportMessageFile (isAdmin, ticketId, messageId, fileId, cbok, cberr)
    {
        let path = isAdmin ? 'support/admin' : 'support/customer';

        let options = this.getCommonHeaders();
        options.responseType = 'blob';
        HTTP
            .get(discovery.worktime_service_url + path + '/ticket/' + ticketId + '/message/' + messageId + '/file/' + fileId, options)
            .then((response) => {
                if (cbok) {
                    cbok(response.data);
                }

                UTILS.downloadDocument(response);

            }).catch(function (error) {
                if (cberr) {
                    cberr(error);
                }
            });
    },

    /////////////////////////////////////////////////////////////////
    //AUDITLOG

    getAuditLog(id, cbok, cberr) {
        this.genericGet('admin/audit-log/' + id, cbok, cberr);
    },

    /////////////////////////////////////////////////////////////////
    //DASHBOARD

    getWidgets(cbok, cberr) {
        this.genericGet('dashboard/config', cbok, cberr);
    },
    getWidgetData(id, context, cbok, cberr) {
        this.genericPost('dashboard/data/' + id, context, cbok, cberr);
    },

    /////////////////////////////////////////////////////////////////
    //REPORT_TYPE 

    getReportTypes(offset, size, search, sortBy, sortDesc, cbok, cberr) {
        this.genericGet('admin/report-type/' + offset + '/' + size + '?search=' + search + '&sortBy=' + sortBy + '&sortDesc=' + sortDesc, cbok, cberr);
    },
    getReportTypeById(id, cbok, cberr) {
        this.genericGet('admin/report-type-by-id/' + id, cbok, cberr);
    },
    storeReportType(data, cbok, cberr) {
        this.genericPost('admin/report-type', data, cbok, cberr);
    },
    deleteReportTypeById(id, cbok, cberr) {
        this.genericDelete('admin/report-type/' + id, cbok, cberr);
    },
    getSupersetGuestToken(id, cbok, cberr) {
        this.genericGet('analytics/reportType/' + id + '/guestToken', cbok, cberr);
    },

    /////////////////////////////////////////////////////////////////
    //KIOSK
    getKiosks(offset, size, search, sortBy, sortDesc, cbok, cberr) {
        this.genericGet('admin/kiosk/' + offset + '/' + size + '?search=' + search + '&sortBy=' + sortBy + '&sortDesc=' + sortDesc, cbok, cberr);
    },
    getKioskById(id, cbok, cberr) {
        this.genericGet('admin/kiosk-by-id/' + id, cbok, cberr);
    },
    storeKiosk(data, cbok, cberr) {
        this.genericPost('admin/kiosk', data, cbok, cberr);
    },
    deleteKiosk(id, cbok, cberr) {
        this.genericDelete('admin/kiosk/' + id, cbok, cberr);
    },

    /////////////////////////////////////////////////////////////////
    //PROJECTCALENDAR

    getEmployeeCalendarPaginated(request, cbok, cberr) {
        this.genericPost('admin/employeeCalendar', request, cbok, cberr);
    },

    /////////////////////////////////////////////////////////////////
    //CUSTOMERS

    getCompaniesPaginated(offset, size, search, sortBy, sortDesc, cbok, cberr) {
        this.genericGet('admin/companies/' + offset + '/' + size + '?search=' + search + '&sortBy=' + sortBy + '&sortDesc=' + sortDesc, cbok, cberr);
    },
    getPartners(cbok, cberr) {
        this.genericGet('admin/getPartners', cbok, cberr);
    },
    getCompanyById(id, cbok, cberr) {
        this.genericGet('admin/company-by-id/' + id, cbok, cberr);
    },
    storeCompany(data, cbok, cberr) {
        this.genericPost('admin/companies', data, cbok, cberr);
    },
    deleteCompany(id, cbok, cberr) {
        this.genericDelete('admin/companies/' + id, cbok, cberr);
    },
    uploadEmployeesFile(data, cbok, cberr) {
        var headers = this.getCommonHeaders().headers;
        headers['Content-Type'] = 'multipart/form-data';

        HTTP.post(discovery.worktime_service_url + 'admin/uploadEmployees',
            data, {
            headers: headers
        })
            .then((response) => {
                cbok(response.data, false);
            }).catch(function (error) {
                if (error.response) {
                    cbok(error.response.data, true);
                    return;
                }
                cberr(error);
            });
    },
    importEmployees(companyId, deleteFile) {
        this.genericPut(`admin/importEmployees/${companyId}/${deleteFile}`);
    },

    /////////////////////////////////////////////////////////////////
    //FORMS 

    encodeBase64(str) {
        if (!str || str === '{}') return str;

        try {
            // Pasa texto a texto UTF-8
            var textEncoder = new TextEncoder();
            var bytes = textEncoder.encode(str);

            // Pasa texto UTF-8 a bytes
            var binary = '';
            for (var i = 0; i < bytes.length; i++) {
                binary += String.fromCharCode(bytes[i]);
            }
            // Pasa bytes a texto base64
            var textBase64 = btoa(binary);

            return textBase64;

        } catch (e) {
            console.error("Error al codificar en base64:", e);
            return "";
        }
    },
    decodeBase64(base64Str) {
        if (!base64Str || base64Str === '{}') return base64Str;

        try {
            // pasa texto Base64 a texto
            var binaryStr = atob(base64Str);

            // pasa texto a bytes
            var bytes = new Uint8Array(binaryStr.length);
            for (var i = 0; i < binaryStr.length; i++) {
                bytes[i] = binaryStr.charCodeAt(i);
            }

            // pasa bytes a texto UTF-8
            var textDecoder = new TextDecoder('utf-8');
            var textUtf8 = textDecoder.decode(bytes);

            return textUtf8;

        } catch (e) {
            console.error("Error al decodificar de base64:", e);
            return "";
        }
    },
    getForms(offset, size, search, sortBy, sortDesc, cbok, cberr) {
        // llama servicio: ResultList<FullForm> getForms(...)
        this.genericGet('admin/form/' + offset + '/' + size + '?search=' + search + '&sortBy=' + sortBy + '&sortDesc=' + sortDesc,
            (response) => {
                // Descodificar la propiedad definition de cada formulario
                if (response && response.entities && Array.isArray(response.entities)) {
                    response.entities.forEach(form => {
                        if (form.definition) {
                            form.definition = this.decodeBase64(form.definition);
                        }
                    });
                }

                // llama al callback
                cbok(response);
            },
            cberr
        );
    },
    getFormById(id, cbok, cberr) {
        // llama servicio: Form getFormById(Long formId)
        this.genericGet('admin/form/' + id,
            (response) => {
                if (response && response.definition) {
                    response.definition = this.decodeBase64(response.definition);
                }

                // llama al callback
                cbok(response);
            },
            cberr
        );
    },
    hasFormSubmissions(id, cbok, cberr) {
        // llama servicio: Boolean hasFormSubmissions(@PathParam("formId") Long formId);
        this.genericGet('admin/form/' + id + '/has-submissions', cbok, cberr);
    },
    storeForm(data, cbok, cberr) {
        // llama servicio: GenericServiceResponse storeForm(Form form)        
        if (data && data.definition) {
            data.definition = this.encodeBase64(data.definition);
        }

        this.genericPost('admin/form', data, cbok, cberr);
    },
    deleteForm(id, cbok, cberr) {
        this.genericDelete('admin/form/' + id, cbok, cberr);
    },

    /////////////////////////////////////////////////////////////////
    //SURVEYS  

    getSurveySubmissions(id, cbok, cberr) {
        this.genericGet('admin/survey/' + id + '/submissions',
            response => {
                // Decodifica form.definition si existe
                if (response && response.form && response.form.definition) {
                    response.form.definition = this.decodeBase64(response.form.definition);
                }
                // Decodifica submissions[].submissionData si existen
                if (response && response.submissions && Array.isArray(response.submissions)) {
                    response.submissions.forEach(sub => {
                        if (sub && sub.submissionData) {
                            sub.submissionData = this.decodeBase64(sub.submissionData);
                        }
                    });
                }
                if (cbok) cbok(response);
            },
            cberr);
    },

    /////////////////////////////////////////////////////////////////
    //ASSESSMENT  

    getAssessmentSubmissions(id, cbok, cberr) {
        this.genericGet('admin/assessment/' + id + '/submissions',
            response => {
                // Decodifica definition si existe
                if (response && response.phase1Form && response.phase1Form.definition) {
                    response.phase1Form.definition = this.decodeBase64(response.phase1Form.definition);
                }
                // Decodifica definition si existe
                if (response && response.phase2Form && response.phase2Form.definition) {
                    response.phase2Form.definition = this.decodeBase64(response.phase2Form.definition);
                }
                // Decodifica submissionData si existen
                if (response && response.phase1Submissions && Array.isArray(response.phase1Submissions)) {
                    response.phase1Submissions.forEach(sub => {
                        if (sub && sub.submissionData) {
                            sub.submissionData = this.decodeBase64(sub.submissionData);
                        }
                    });
                }
                // Decodifica submissionData si existen
                if (response && response.phase2Submissions && Array.isArray(response.phase2Submissions)) {
                    response.phase2Submissions.forEach(sub => {
                        if (sub && sub.submissionData) {
                            sub.submissionData = this.decodeBase64(sub.submissionData);
                        }
                    });
                }
                if (cbok) cbok(response);
            },
            cberr);
    },

    ////////////////////////////////////////////////////
    //DATA BAGS

    getDataBag(key, cbok, cberr) {
        this.genericGet('user/databag/' + key, cbok, cberr);
    },
    storeDataBag(data, cbok, cberr) {
        this.genericPost('user/databag', data, cbok, cberr);
    },
    deleteDataBag(id, cbok, cberr) {
        this.genericDelete('user/databag/' + id, cbok, cberr);
    },
    ////////////////////////////////////////////////////
    //ADMIN CONFIGURATION
    getAdminCongiguration(id, cbok, cberr) {
        this.genericGet('admin/config/' + id, cbok, cberr);
    },
    storeAdminCongiguration(data, cbok, cberr) {
        this.genericPost('admin/config', data, cbok, cberr);
    },
    deleteAdminCongiguration(id, cbok, cberr) {
        this.genericDelete('admin/config/' + id, cbok, cberr);
    },

    /////////////////////////////////////////////////////////////////
    //AI SEARCH

    doAISearch(topic, prompt, cbok, cberr) {
        this.genericGet('ai/search?t=' + topic + '&q=' + encodeURI(prompt), cbok, cberr);
    },
    getAISearchData(id, context, cbok, cberr) {
        this.genericPost('ai/data/' + id, context, cbok, cberr);
    },

    ////////////////////////////////////////////////////
    //ACTIVITY TYPE

    getActivityTypeById(id, cbok, cberr) {
        this.genericGet('admin/activity-types-by-id/' + id, cbok, cberr);
    },
    storeActivityType(data, cbok, cberr) {
        this.genericPost('admin/activity-type', data, cbok, cberr);
    },
    testActivityTypeScript(data, cbok, cberr) {
        this.genericPost('admin/activity-type/test-script', data, cbok, cberr);
    },
    deleteActivityType(id, cbok, cberr) {
        this.genericDelete('admin/activity-type/' + id, cbok, cberr);
    },
    getActivityCountByActivityType(id, cbok, cberr) {
        this.genericGet('admin/activity-count-by-activity-type/' + id, cbok, cberr);
    },
    /*getWorkPlaces(cbok, cberr)
    {
        this.genericGet('admin/getworkPlace', cbok, cberr);
    },*/

    ////////////////////////////////////////////////////
    //DEPARTMENT

    getDepartments(data, cbok, cberr) {
        this.genericGet('admin/departments', data, cbok, cberr);
    },
    getDepartmentsWithoutGlobalFilters(cbok, cberr) {
        this.genericGet('admin/departments', cbok, cberr, { omitGlobalFilters: true });
    },
    getDepartmentById(id, cbok, cberr) {
        this.genericGet('admin/departments/' + id, cbok, cberr);
    },
    storeDepartment(data, cbok, cberr) {
        this.genericPost('admin/departments', data, cbok, cberr);
    },
    deleteDepartment(id, cbok, cberr) {
        this.genericDelete('admin/departments/' + id, cbok, cberr);
    },

    ////////////////////////////////////////////////////
    //DOCUMENT CATEGORY

    getDocumentCategoryById(id, cbok, cberr) {
        this.genericGet('admin/document-category-by-id/' + id, cbok, cberr);
    },
    storeDocumentCategory(data, cbok, cberr) {
        this.genericPost('admin/document-category', data, cbok, cberr);
    },
    deleteDocumentCategory(id, cbok, cberr) {
        this.genericDelete('admin/document-category/' + id, cbok, cberr);
    },
    ////////////////////////////////////////////////////
    //DIALOG BUILDER

    dialogBuilderGET(path, cbok, cberr) {
        this.genericGet(path, cbok, cberr);
    },
    dialogBuilderPOST(path, data, cbok, cberr) {
        this.genericPost(path, data, cbok, cberr);
    },
    dialogBuilderDELETE(path, cbok, cberr) {
        this.genericDelete(path, cbok, cberr);
    },

    /////////////////////////////////////////////////////////////////
    //CALENDAR

    getCalendars(cbok, cberr) {
        this.genericGet('admin/calendar', cbok, cberr);
    },
    copyCalendarExercise(data, cbok, cberr) {
        this.genericPost('admin/copyCalendarExercise', data, cbok, cberr);
    },
    getCountry(id, cbok, cberr) {
        this.genericGet('admin/country/' + id, cbok, cberr);
    },
    getCalendarHolidays(countryId, stateId, locale, year, cbok, cberr) {
        this.genericGet(`admin/getCalendarHolidays/${countryId}/${stateId}/${locale}/${year}`, cbok, cberr);
    },
    addCalendarHolidays(data, cbok, cberr) {
        this.genericPost('admin/addCalendarHolidays', data, cbok, cberr);
    },

    /////////////////////////////////////////////////////////////////
    //REFUND TRANSACTION

    refundTransaction(id, cbok, cberr) {
        this.genericPut('admin/refund/' + id, null, cbok, cberr);
    },
    getTransactions(cbok, cberr) {
        this.genericGet('admin/transactions', cbok, cberr);
    },

    /////////////////////////////////////////////////////////////////
    //Complaint

    getComplaint(id, cbok, cberr) {
        this.genericGet('complaint/get-full-complaint/' + id, cbok, cberr);
    },
    createComplaint(data, cbok, cberr) {
        this.genericPost('complaint/create-complaint', data, cbok, cberr);
    },
    updateComplaint(data, cbok, cberr) {
        this.genericPut('complaint/update-complaint', data, cbok, cberr);
    },
    downloadComplaintFile(companyId, complaintId, fileId, cbok, cberr) {
        let options = this.getCommonHeaders();
        options.responseType = 'blob';
        HTTP
            .get(discovery.worktime_service_url + 'complaint/download-complaint-file-by-id/' + companyId + '/' + complaintId + '/' + fileId, options)
            .then((response) => {
                if (cbok) {
                    cbok(response.data);
                }

                UTILS.downloadDocument(response);

            }).catch(function (error) {
                if (cberr) {
                    cberr(error);
                }
            });
    },
    createComplaintMessage(data, cbok, cberr) {
        this.genericPost('complaint/create-complaint-message', data, cbok, cberr);
    },
    downloadComplaintMessageFile(companyId, complaintId, messageId, fileId, cbok, cberr) {
        let options = this.getCommonHeaders();
        options.responseType = 'blob';
        HTTP
            .get(discovery.worktime_service_url + 'complaint/download-complaint-message-file-by-id/' + companyId + '/' + complaintId + '/' + messageId + '/' + fileId, options)
            .then((response) => {
                if (cbok) {
                    cbok(response.data);
                }

                UTILS.downloadDocument(response);

            }).catch(function (error) {
                if (cberr) {
                    cberr(error);
                }
            });
    },

    /////////////////////////////////////////////////////////////////
    // COMPLAINTCONFIG

    getComplaintExternalContentByCompanyId(companyId, cbok, cberr) {
        this.genericGet('complaint/get-complaint-external-content-by-company-id/' + companyId, cbok, cberr);
    },
    updateMyCompany(data, cbok, cberr) {
        this.genericPost('admin/company', data, cbok, cberr);
    },
    updateComplaintTerm(companyId, cbok, cberr) {
        this.genericPut('complaint/update-complaint-term', companyId, cbok, cberr);
    },
    updateComplaintExternalContent(data, cbok, cberr) {
        this.genericPut('complaint/update-complaint-external-content', data, cbok, cberr);
    },

    ////////////////////////////////////////////////////
    //WEBHOOKS

    getWebhookById(id, cbok, cberr) {
        this.genericGet('admin/webhookById/' + id, cbok, cberr);
    },
    storeWebhook(data, cbok, cberr) {
        this.genericPost('admin/webhook', data, cbok, cberr);
    },
    deleteWebhook(id, cbok, cberr) {
        this.genericDelete('admin/webhook/' + id, cbok, cberr);
    },

    ////////////////////////////////////////////////////
    //ACTIVITY_TYPE

    /*getProjects(cbok, cberr)
    {
        this.genericGet('admin/projectsAll', cbok, cberr);
    }, 
    getEmployee(data, cbok, cberr)
    {
        this.genericGet('admin/employee', data, cbok, cberr);
    },*/

    ////////////////////////////////////////////////////
    //TELEWORK

    getFullDailyWorkdayById(id, cbok, cberr) {
        this.genericGet('admin/fullDailyWorkday/' + id, cbok, cberr);
    },
    sendMessage(data, cbok, cberr) {
        this.genericPost('admin/message', data, cbok, cberr);
    },

    ////////////////////////////////////////////////////
    //HOJA DE GASTOS

    getExpenseSheetById(id, cbok, cberr) {
        this.genericGet('admin/expense-sheet/' + id, cbok, cberr);
    },
    downloadExpenseSheetItemDocument(sheetId, sheetItemId, cbok, cberr) {
        let options = this.getCommonHeaders();
        options.responseType = 'blob';
        HTTP
            .get(`${discovery.worktime_service_url}admin/expense-sheet-item/${sheetId}/download/${sheetItemId}`, options)
            .then((response) => {
                if (cbok) {
                    cbok(response.data);
                }

                UTILS.downloadDocument(response);

            }).catch(function (error) {
                if (cberr) {
                    cberr(error);
                }
            });
    },
    getExpensesCountByExpenseCategoryId(id, cbok, cberr) {
        this.genericGet(`admin/expense-sheet-category/${id}/count`, cbok, cberr);
    },

    ////////////////////////////////////////////////////
    //MI LICENCIA

    getSKULicensingInfo(cbok, cberr) {
        this.genericGet('admin/skuLicensingInfo', cbok, cberr);
    },
    validateVoucher(data, cbok, cberr) {
        this.genericPost('admin/validateVoucher', data, cbok, cberr);
    },
    createPurchaseOrder(data, cbok, cberr) {
        this.genericPost('admin/purchaseOrder', data, cbok, cberr);
    },

    ////////////////////////////////////////////////////
    //WORKPLACES

    getWorkplaceById(id, cbok, cberr) {
        this.genericGet('admin/workPlaces/' + id, cbok, cberr);
    },
    getEmployeeCountByWorkPlace(id, cbok, cberr) {
        this.genericGet('admin/employeeCountByWorkPlace/' + id, cbok, cberr);
    },
    storeWorkplace(data, cbok, cberr) {
        this.genericPost('admin/workPlaces', data, cbok, cberr);
    },
    deleteWorkplace(id, cbok, cberr) {
        this.genericDelete('admin/workPlaces/' + id, cbok, cberr);
    },

    ////////////////////////////////////////////////////
    //LEGAL ENTITIES

    getLegalEntities(cbok, cberr, options = {}) {
        this.genericGet('admin/legal-entities', cbok, cberr, options);
    },
    getLegalEntitiesWithoutGlobalFilters(cbok, cberr) {
        this.genericGet('admin/legal-entities', cbok, cberr, { omitGlobalFilters: true });
    },
    getLegalEntityById(id, cbok, cberr) {
        this.genericGet('admin/legal-entities/' + id, cbok, cberr);
    },
    storeLegalEntity(data, cbok, cberr) {
        this.genericPost('admin/legal-entities', data, cbok, cberr);
    },
    deleteLegalEntity(id, cbok, cberr) {
        this.genericDelete('admin/legal-entities/' + id,
            (response) => {
                if (response && response.rsOK === false) {
                    if (cberr) {
                        cberr(response.message || 'Delete failed');
                    }
                    return;
                }

                if (cbok) {
                    cbok(response);
                }
            },
            cberr);
    },

    ////////////////////////////////////////////////////
    //WORKPLACES-HOLIDAYS

    getWorkplaceHolidays(id, cbok, cberr) {
        this.genericGet('admin/workplaceHolidays/' + id, cbok, cberr);
    },
    deleteWorkplaceHoliday(id, cbok, cberr) {
        this.genericDelete('admin/workplaceHoliday/' + id, cbok, cberr);
    },
    storeWorkplaceHoliday(data, cbok, cberr) {
        this.genericPost('admin/workplaceHoliday', data, cbok, cberr);
    },

    ////////////////////////////////////////////////////
    //EQUIPOS / PROYECTOS

    getProjectById(id, cbok, cberr) {
        this.genericGet('admin/project/' + id, cbok, cberr);
    },
    getFullProjectsEmployeesByProjectId(id, cbok, cberr) {
        this.genericGet('admin/fullProjectsEmployeesByProjectId/' + id, cbok, cberr);
    },
    createProject(data, cbok, cberr) {
        this.genericPost('admin/createProject', data, cbok, cberr);
    },
    storeProject(data, cbok, cberr) {
        this.genericPost('admin/project', data, cbok, cberr);
    },
    deleteProjectById(id, cbok, cberr) {
        this.genericDelete('admin/project/' + id, cbok, cberr);
    },
    getFullProjectEmployeesByProjectList(data, cbok, cberr) {
        this.genericPost('admin/geFulltProjectEmployeesByProjectList', data, cbok, cberr);
    },
    deleteProjectEmployeesByProjectList(data, cbok, cberr) {
        this.genericPost('admin/deleteProjectEmployeesByProjectList', data, cbok, cberr);
    },
    addProjectEmployees(data, cbok, cberr) {
        this.genericPost('admin/addProjectEmployee', data, cbok, cberr);
    },
    storeProjectEmployee(data, cbok, cberr) {
        this.genericPost('admin/projectEmployee', data, cbok, cberr);
    },
    deleteProjectEmployeeById(id, cbok, cberr) {
        this.genericDelete('admin/project/employees/' + id, cbok, cberr);
    },

    ////////////////////////////////////////////////////
    //REGLAS DE CALENDARIO

    getCalendarRulesByCalendarId(calendarId, cbok, cberr) {
        this.genericGet(`admin/calendar-rule/list/${calendarId}`, cbok, cberr);
    },
    storeCalendarRule(data, cbok, cberr) {
        this.genericPost('admin/calendar-rule', data, cbok, cberr);
    },
    deleteCalendarRuleById(id, cbok, cberr) {
        this.genericDelete(`admin/calendar-rule/${id}`, cbok, cberr);
    },
    swapCalendarRules(calendarId, id1, id2, cbok, cberr) {
        this.genericPost(`admin/calendar/${calendarId}/swap-rules/${id1}/${id2}`, null, cbok, cberr);
    },
    executeCalendarRulesByCalendarId(calendarId, data, cbok, cberr) {
        this.genericPost(`admin/calendar/${calendarId}/execute-rules`, data, cbok, cberr);
    },
    copyCalendarRules(srcCalendarId, dstCalendarId, cbok, cberr) {
        this.genericPost(`admin/calendar/${srcCalendarId}/copy-rules/${dstCalendarId}`, null, cbok, cberr);
    },
    getFullCalendars(cbok, cberr) {
        this.genericGet('admin/full-calendar', cbok, cberr);
    },
    createNextCalendarExercise(calendarId, cbok, cberr) {
        this.genericPost(`admin/calendar/${calendarId}/create-next-exercise`, null, cbok, cberr);
    },

    ////////////////////////////////////////////////////
    //DESEMPEÑO

    storeAssessmentReviews(data, cbok, cberr) {
        this.genericPost('admin/assessment-reviews', data, cbok, cberr);
    },

    getAssessmentPaginated(id, cbok, cberr) {
        this.genericGet('admin/assessmentReview/' + id, cbok, cberr);
    },

    getAssessmentReviewsByAssessmentId(filter, cbok, cberr) {
        this.genericPost('admin/assessment-reviews-filter', filter, cbok, cberr);
    },

    getFormAssessmentReviewInfo(reviewId, phase, cbok, cberr) {
        const url = `admin/assessmentreview/form/${reviewId}/${phase}`;
        this.genericGet(url,
            (response) => {
                if (response && response.form && response.form.definition) {
                    response.form.definition = this.decodeBase64(response.form.definition);
                }
                if (response && response.lastSubmission && response.lastSubmission.submissionData) {
                    response.lastSubmission.submissionData = this.decodeBase64(response.lastSubmission.submissionData);
                }

                // llama al callback
                cbok(response);
            },
            cberr
        );
    },

    storeAssessmentReview(data, cbok, cberr) {
        this.genericPost('admin/assessment-review', data, cbok, cberr);
    },

    deleteAssessmentReviewById(id, cbok, cberr) {
        this.genericDelete('admin/assessment-review/' + id, cbok, cberr);
    },

    getAssessmentReviewById(id, cbok, cberr) {
        this.genericGet('admin/assessment-review-by-id/' + id, cbok, cberr);
    },
    ////////////////////////////////////////////////////
    //ASISTENTES

    storeProjectCalendar(data, cbok, cberr) {
        this.genericPost('admin/projectCalendarEditor', data, cbok, cberr)
    },

    processVacationAssistant(data, cbok, cberr) {
        this.genericPost('admin/process-vacation-assistant', data, cbok, cberr)
    },

    validateVacationAssistant(data, cbok, cberr) {
        this.genericPost('admin/validate-vacation-assistant', data, cbok, cberr)
    },

    ////////////////////////////////////////////////////
    //NOTIFICACIONES

    getMessages(data, cbok, cberr) {
        this.genericGet('admin/message', data, cbok, cberr);
    },

    getMessageById(id, cbok, cberr) {
        this.genericGet('admin/message-by-id/' + id, cbok, cberr);
    },

    // publishMessage(data, cbok, cberr) Se está utilizando en telework - revisarlo bien
    // {
    //     this.genericPost('admin/message', data, cbok, cberr);
    // },

    deleteMessage(id, cbok, cberr) {
        this.genericDelete('admin/message/' + id, cbok, cberr);
    },
    getMessageResponses(id, cbok, cberr) {
        this.genericGet('admin/messageResponses/' + id, cbok, cberr);
    },

    ////////////////////////////////////////////////////
    //NOVEDADES

    getReleases(cbok, cberr) {
        this.genericGet('admin/release', cbok, cberr);
    },

    getReleaseById(id, cbok, cberr) {
        this.genericGet('admin/release/' + id, cbok, cberr);
    },

    storeRelease(data, cbok, cberr) {
        this.genericPost('admin/release', data, cbok, cberr);
    },

    deleteReleaseById(id, cbok, cberr) {
        this.genericDelete('admin/release/' + id, cbok, cberr);
    },
    ////////////////////////////////////////////////////
    //ADMINISTRADORES

    getFullProfileById(id, cbok, cberr) {
        this.genericGet('admin/full-admin-profile/' + id, cbok, cberr);
    },

    getEmployeesByEmail(cbok, cberr) {
        this.genericPost('admin/employeesByEmail', cbok, cberr);
    },

    existAdminProfile(employeeId, companyId, cbok, cberr) {
        this.genericGet('admin/exist-admin-profile/' + employeeId + '/' + companyId, cbok, cberr);
    },

    deleteAdminProfile(id, cbok, cberr) {
        this.genericDelete('admin/admin-profile/' + id, cbok, cberr);
    },

    storeAdminProfile(data, cbok, cberr) {
        this.genericPost('admin/admin-profile', data, cbok, cberr);
    },

    iAmPartner(id, cbok, cberr) {
        this.genericGet('admin/iAmPartner/' + id, cbok, cberr);
    },

    ////////////////////////////////////////////////////
    // AI

    getAiAssistantResponse(prompt, chatId, cbok, cberr) {
        this.genericGet('ai/v2/search?q=' + encodeURIComponent(prompt) + '&t=ASSISTANT&id=' + chatId, cbok, cberr);
    },
    getUserChat(chatId, cbok, cberr) {
        this.genericGet('ai/v2/chat/' + chatId, cbok, cberr);
    },
    getAdminUserChat(chatId, cbok, cberr) {
        this.genericGet('ai/v2/admin/chat/' + chatId, cbok, cberr);
    },
    getLastUserChat(cbok, cberr) {
        this.genericGet('ai/v2/chat', cbok, cberr);
    },
    startNewChat(chatId, cbok, cberr) {
        this.genericPost('ai/v2/chat/' + chatId, {}, cbok, cberr);
    },
    postFeedback(chatId, feedback, cbok, cberr) {
        this.genericPost('ai/v2/chat/' + chatId + '/feedback', feedback, cbok, cberr);
    },
    createUserChatFromPrompt(promptCode, context, cbok, cberr) {
        this.genericPost('ai/v2/chat/prompt/' + promptCode, context, cbok, cberr);
    },
    ////////////////////////////////////////////////////
    //PARTNERS

    getPartnerById(id, cbok, cberr) {
        this.genericGet('admin/getPartners/' + id, cbok, cberr);
    },
    storePartner(data, cbok, cberr) {
        this.genericPost('admin/updatePartners', data, cbok, cberr);
    },
    deletePartner(id, cbok, cberr) {
        this.genericDelete('admin/deletePartner/' + id, cbok, cberr);
    },
    otherPartnersDependOnPartner(id, cbok, cberr) {
        this.genericGet('admin/otherPartnersDependOnPartner/' + id, cbok, cberr);
    },

    ////////////////////////////////////////////////////
    //ACTUALIDAD

    getNewsById(id, cbok, cberr) {
        this.genericGet('admin/news-by-id/' + id, cbok, cberr);
    },
    storeNews(data, cbok, cberr) {
        this.genericPost('admin/news', data, cbok, cberr);
    },
    deleteNews(id, cbok, cberr) {
        this.genericDelete('admin/news/' + id, cbok, cberr);
    },
    uploadNewsFile(data, cbok, cberr) {
        var headers = this.getCommonHeaders().headers;
        headers['Content-Type'] = 'multipart/form-data';

        HTTP
            .post(discovery.worktime_service_url + 'admin/newsPicture/',
                data, {
                headers: headers
            })
            .then((response) => {
                cbok(response.data, false);
            }).catch(function (error) {
                if (error.response) {
                    cbok(error.response.data, true);
                    return;
                }
                cberr(error);
            }
            );
    },

    ////////////////////////////////////////////////////
    //ASSESSMENT NOTIFICATIONS

    notifyPendingReviews(assessmentId, phase, cbok, cberr) {
        this.genericPost(`admin/assessments/${assessmentId}/pending-reviews/notify?phase=${phase}`, null, cbok, cberr);
    },

    ////////////////////////////////////////////////////
    //PAID ABSENCES CATEGORY

    getPaidAbsencesCategoryById(id, cbok, cberr) {
        this.genericGet('admin/paid-absences-category-by-id/' + id, cbok, cberr);
    },
    storePaidAbsencesCategory(data, cbok, cberr) {
        this.genericPost('admin/paid-absences-category', data, cbok, cberr);
    },
    getPaidAbsencesCountByCategory(id, cbok, cberr) {
        this.genericGet('admin/paid-absences-count-by-paid-absences-category/' + id, cbok, cberr);
    },
    deletePaidAbsencesCategory(id, cbok, cberr) {
        this.genericDelete('admin/paid-absences-category/' + id, cbok, cberr);
    },

    ////////////////////////////////////////////////////
    //ADDITIONAL HOURS CATEGORY

    getAdditionalHoursCategoryById(id, cbok, cberr) {
        this.genericGet('admin/additional-hours-category-by-id/' + id, cbok, cberr);
    },
    storeAdditionalHoursCategory(data, cbok, cberr) {
        this.genericPost('admin/additional-hours-category', data, cbok, cberr);
    },
    getAdditionalHoursCategoryUsageCount(id, cbok, cberr) {
        this.genericGet('admin/additional-hours-category-usage-count/' + id, cbok, cberr);
    },
    getAdditionalHoursCategoryEmployeeCount(id, cbok, cberr) {
        this.genericGet('admin/additional-hours-category-employee-count/' + id, cbok, cberr);
    },
    deleteAdditionalHoursCategory(id, cbok, cberr) {
        this.genericDelete('admin/additional-hours-category/' + id, cbok, cberr);
    },
    getAdditionalHoursCategories(cbok, cberr) {
        this.genericGet('admin/additional-hours-categories', cbok, cberr);
    },

    ////////////////////////////////////////////////////
    // VACATION POLICY

    changeHoursBagUnit(data, cbok, cberr) {
        this.genericPost('admin/vacation/changeHoursBagUnit', data, cbok, cberr);
    },
    getVacationPolicies(textFilter, cbok, cberr) {
        const safeFilter = textFilter && textFilter.trim().length > 0
            ? encodeURIComponent(textFilter)
            : encodeURIComponent(' ');

        this.genericGet('admin/vacation-policies/' + safeFilter, cbok, cberr);
    },
    storeVacationPolicy(data, cbok, cberr) {
        this.genericPost('admin/vacation-policy', data, cbok, cberr);
    },
    deleteVacationPolicy(id, cbok, cberr) {
        this.genericDelete('admin/vacation-policy/' + id, cbok, cberr);
    },
    updateBalanceVacation(data, cbok, cberr) {
        this.genericPut('admin/vacation/updateBalanceVacation', data, cbok, cberr);
    },
    getCurrentAdminFilters(companyId) {
        const resolvedCompanyId = companyId
            || this.getContextValue('worktime.admin.company.id')
            || this.getContextValue('worktime.employee.company.id');

        const parseFilterValue = (key) => {
            const value = window.localStorage.getItem(key);

            if (!value || value === '-1' || value === 'null') {
                return null;
            }

            const numericValue = Number(value);
            return Number.isNaN(numericValue) ? null : numericValue;
        };

        if (!resolvedCompanyId) {
            return {
                workplaceId: null,
                departmentId: null
            };
        }

        return {
            workplaceId: parseFilterValue(`filter.company_id_${resolvedCompanyId}.workplace.id`),
            departmentId: parseFilterValue(`filter.company_id_${resolvedCompanyId}.department.id`)
        };
    },

    ////////////////////////////////////////////////////
    //TRAINING CATEGORY

    getTrainingCategoryById(id, cbok, cberr) {
        this.genericGet('admin/training-category-by-id/' + id, cbok, cberr);
    },
    storeTrainingCategory(data, cbok, cberr) {
        this.genericPost('admin/training-category', data, cbok, cberr);
    },
    getTrainingCategoryUsageCount(id, cbok, cberr) {
        this.genericGet('admin/training-category-usage-count/' + id, cbok, cberr);
    },
    deleteTrainingCategory(id, cbok, cberr) {
        this.genericDelete('admin/training-category/' + id, cbok, cberr);
    },
    getTrainingCategories(cbok, cberr) {
        this.genericGet('admin/training-categories', cbok, cberr);
    },

    ////////////////////////////////////////////////////
    //TRAINING COURSE

    getTrainingCourseById(id, cbok, cberr) {
        this.genericGet('admin/training-course-by-id/' + id, cbok, cberr);
    },
    storeTrainingCourse(data, cbok, cberr) {
        this.genericPost('admin/training-course', data, cbok, cberr);
    },
    uploadTrainingCourseThumbnail(trainingCourseId, data, cbok, cberr) {
        var headers = this.getCommonHeaders().headers;
        headers['Content-Type'] = 'multipart/form-data';

        HTTP
            .post(discovery.worktime_service_url + 'admin/trainingCoursePicture/' + trainingCourseId,
                data, {
                headers: headers
            })
            .then((response) => {
                cbok(response.data);
            }).catch(function (error) {
                if (cberr) {
                    cberr(error);
                }
            });
    },
    deleteTrainingCourseThumbnail(trainingCourseId, cbok, cberr) {
        this.genericDelete('admin/trainingCoursePicture/' + trainingCourseId, cbok, cberr);
    },
    getTrainingCourseUsageCount(id, cbok, cberr) {
        this.genericGet('admin/training-course-usage-count/' + id, cbok, cberr);
    },
    deleteTrainingCourse(id, cbok, cberr) {
        this.genericDelete('admin/training-course/' + id, cbok, cberr);
    },
    getTrainingCourses(cbok, cberr) {
        this.genericGet('admin/training-courses', cbok, cberr);
    },

    ////////////////////////////////////////////////////
    //TRAINING PROGRAM

    getTrainingProgramById(id, cbok, cberr) {
        this.genericGet('admin/training-program-by-id/' + id, cbok, cberr);
    },
    storeTrainingProgram(data, cbok, cberr) {
        this.genericPost('admin/training-program', data, cbok, cberr);
    },
    getTrainingProgramUsageCount(id, cbok, cberr) {
        this.genericGet('admin/training-program-usage-count/' + id, cbok, cberr);
    },
    deleteTrainingProgram(id, cbok, cberr) {
        this.genericDelete('admin/training-program/' + id, cbok, cberr);
    },
    getTrainingPrograms(cbok, cberr) {
        this.genericGet('admin/training-programs', cbok, cberr);
    },

    ////////////////////////////////////////////////////
    //TRAINING ACTION

    getProcedureDefinitions(cbok, cberr) {
        this.genericGet('admin/procedureDefinition', cbok, cberr);
    },
    getTrainingActionById(id, cbok, cberr) {
        this.genericGet('admin/training-action-by-id/' + id, cbok, cberr);
    },
    storeTrainingAction(data, cbok, cberr) {
        this.genericPost('admin/training-action', data, cbok, cberr);
    },
    uploadTrainingActionThumbnail(trainingActionId, data, cbok, cberr) {
        var headers = this.getCommonHeaders().headers;
        headers['Content-Type'] = 'multipart/form-data';

        HTTP
            .post(discovery.worktime_service_url + 'admin/trainingActionPicture/' + trainingActionId,
                data, {
                headers: headers
            })
            .then((response) => {
                cbok(response.data);
            }).catch(function (error) {
                if (cberr) {
                    cberr(error);
                }
            });
    },
    deleteTrainingActionThumbnail(trainingActionId, cbok, cberr) {
        this.genericDelete('admin/trainingActionPicture/' + trainingActionId, cbok, cberr);
    },
    cancelTrainingAction(data, cbok, cberr) {
        this.genericPost('admin/training-action-cancel', data, cbok, cberr);
    },
    getTrainingActionEnrollmentCount(id, cbok, cberr) {
        this.genericGet('admin/training-action-enrollment-count/' + id, cbok, cberr);
    },
    getTrainingYearlyPlan(year, cbok, cberr) {
        this.genericGet('admin/training-yearly-plan/' + year, cbok, cberr);
    },
    deleteTrainingAction(id, cbok, cberr) {
        this.genericDelete('admin/training-action/' + id, cbok, cberr);
    },
    getTrainingActions(cbok, cberr) {
        this.genericGet('admin/training-actions', cbok, cberr);
    },

    ////////////////////////////////////////////////////
    //TRAINING ENROLLMENT

    getTrainingActionEnrollments(id, cbok, cberr) {
        this.genericGet('admin/training-action-enrollments/' + id, cbok, cberr);
    },
    storeTrainingEnrollment(data, cbok, cberr) {
        this.genericPost('admin/training-enrollment', data, cbok, cberr);
    },
    storeTrainingEnrollmentBatch(data, cbok, cberr) {
        this.genericPost('admin/training-enrollment-batch', data, cbok, cberr);
    },
    storeTrainingEnrollmentResultsBatch(data, cbok, cberr) {
        this.genericPost('admin/training-enrollment-results-batch', data, cbok, cberr);
    },
    sendTrainingEnrollmentNotification(data, cbok, cberr) {
        this.genericPost('admin/training-enrollment-notification', data, cbok, cberr);
    },
    uploadTrainingEnrollmentCertificate(trainingEnrollmentId, data, cbok, cberr) {
        HTTP
            .post(discovery.worktime_service_url + 'admin/training-enrollment/' + trainingEnrollmentId + '/certificate',
                data, this.getCommonHeaders())
            .then((response) => {
                cbok(response.data);
            }).catch(function (error) {
                if (cberr) {
                    cberr(error);
                }
            });
    },
    downloadTrainingEnrollmentCertificate(trainingEnrollmentId, cbok, cberr) {
        let options = this.getCommonHeaders();
        options.responseType = 'blob';
        HTTP
            .get(discovery.worktime_service_url + 'admin/training-enrollment/' + trainingEnrollmentId + '/certificate', options)
            .then((response) => {
                if (cbok) {
                    cbok(response.data);
                }

                UTILS.downloadDocument(response);
            }).catch(function (error) {
                if (cberr) {
                    cberr(error);
                }
            });
    },
    deleteTrainingEnrollment(id, cbok, cberr) {
        this.genericDelete('admin/training-enrollment/' + id, cbok, cberr);
    },

    ////////////////////////////////////////////////////
    //TRAINING BUDGET

    getTrainingBudgetById(id, cbok, cberr) {
        this.genericGet('admin/training-budget-by-id/' + id, cbok, cberr);
    },
    storeTrainingBudget(data, cbok, cberr) {
        this.genericPost('admin/training-budget', data, cbok, cberr);
    },
    getTrainingBudgetUsageCount(id, cbok, cberr) {
        this.genericGet('admin/training-budget-usage-count/' + id, cbok, cberr);
    },
    deleteTrainingBudget(id, cbok, cberr) {
        this.genericDelete('admin/training-budget/' + id, cbok, cberr);
    },
    getTrainingBudgets(cbok, cberr) {
        this.genericGet('admin/training-budgets', cbok, cberr);
    },
}
